<template>
    <div class="complaintsList">
        <div class="complaint_problem">
            <div class="complaintList_img">
                <img src="../../assets/images/service/p.png" alt="">
                <span>{{cList.username}}</span>
            </div>
            <p class="publish_time">{{cList.add_time}}</p>
            <p class="complaint_content">{{cList.content}}</p>
        </div>
        <div class="complaint_answer" v-for="(n,i) in cList.reply" :key="i">
            <div class="complaintList_img">
                <span>{{n.username}}</span>
            </div>
            <p class="publish_time">{{n.add_time}}</p>
            <p class="complaint_content">{{n.content}}</p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "complaintsList",
        props:['cList'],
        data:function () {
            return {
                answer:''
            }
        }
    }
</script>

<style scoped lang="less">
@import '../../assets/less/common.less';
    .complaintsList {
        width: 90%;
        padding: 0 5%;
        .border-bottom(5px; @bg);

        .complaintList_img {
            height: 55px;
            line-height: $height;
            font-size: .8rem;
        }

        .publish_time {
            color:@word;
            font-size:@font - .4;
            line-height: 24px ;
        }
        .complaint_content {
            line-height: 30px   ;
        }

        .complaint_problem {
            .border-bottom;
            .complaintList_img {
                img{
                    float: left;
                    width: 10%;
                    margin: 10px 10px  0 0;
                }
            }

        }
        .complaint_answer  {
            .complaintList_img{
                width: 90%;

                padding-left: 10%;
                position: relative;
                span{
                    margin-left: 10px;
                }
                &:before {
                    top:6px;
                    content: '';
                    background:url('../../assets/images/service/service_sprite.png') no-repeat 0  -114px;
                    width: 12%;
                    height: 55px;
                    left:0;
                    background-size: 40px auto;

                }

            }

        }


    }


</style>
